import { isSafari, isMobile } from 'mobile-device-detect'

export default {
  methods: {
    setImage (e) {
      if (e.target.files.length > 0) {
        const file = e.target.files[0]

        if (file.type.indexOf('image/') === -1) {
          alert('Please select an image file')
          return
        }

        if (typeof FileReader === 'function') {
          const reader = new FileReader()
          reader.onload = event => {
            this.resizeImage(event.target.result).then(value => {
              this.item.image_url = value
              this.item.$save()

              this.selected = false

              // rebuild cropperjs with the updated source
              this.$refs.cropper.replace(value)
            })
          }

          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      }
    },

    /**
     * handle crop image
     */
    async handleCropImg () {
      if (!this.$refs.cropper) {
        return
      }

      const cropCanvas = this.$refs.cropper.getCroppedCanvas()
      if (cropCanvas) {
        this.item.image_url = cropCanvas.toDataURL()
        return this.item.$save()
      }
    },

    /**
     * reset to default image
     */
    resetImage () {
      this.$refs.cropper.reset()
    },

    /**
     * Crop Image Base64
     * @param BASE64
     * @param MAX_WIDTH
     * @param MAX_HEIGHT
     * @return {Promise<void>}
     */
    resizeImage (BASE64, MAX_WIDTH = 900, MAX_HEIGHT = 900) {
      if (isMobile) MAX_WIDTH = MAX_HEIGHT = 600

      const IMAGE = new Image()
      IMAGE.src = BASE64
      return new Promise(resolve => {
        IMAGE.onload = function () {
          const sizeImage = {}
          sizeImage.width = IMAGE.width
          sizeImage.height = IMAGE.height
          
          let width = sizeImage.width
          let height = sizeImage.height
          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }

          let canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height

          let ctx = canvas.getContext('2d')
          ctx.drawImage(IMAGE, 0, 0, width, height)

          const quality = isMobile ? 0.5 : 1
          resolve(canvas.toDataURL('image/jpeg', quality))
        }
      })
    },

    /**
     * Convert Base64 to Blob
     * @param b64Data
     * @param contentType
     * @param sliceSize
     * @return {Blob}
     */
    convertb64toBlob (b64Data, contentType = '', sliceSize = 512) {
      const byteCharacters = atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, { type: contentType })
    }
  }
}